/**
 * The search of the «Categories and profiles» step (/analysis-setup/categories)
 * — shared with the redirect of its old path (/analysis-setup/criteria, #2491),
 * so a tab added to the step reaches the links already sent to the old one.
 */

export type CategoriesTab = 'categories' | 'profiles' | 'stages';

export interface CategoriesSearch {
  profileId?: string;
  tab?: CategoriesTab;
}

export const validateCategoriesSearch = (
  search: Record<string, unknown>
): CategoriesSearch => ({
  profileId: typeof search.profileId === 'string' ? search.profileId : undefined,
  tab:
    search.tab === 'categories' || search.tab === 'profiles' || search.tab === 'stages'
      ? search.tab
      : undefined,
});
